// Image utility component to handle public folder images properly
import React from 'react';

const PublicImage = ({ src, alt, className, style, loading, sizes, ...props }) => {
  // Handle images from public folder
  const imageSrc = src.startsWith('/') ? src : `/${src}`;
  
  return (
    <img
      src={process.env.PUBLIC_URL + imageSrc}
      alt={alt}
      className={className}
      style={style}
      loading={loading}
      sizes={sizes}
      onError={(e) => {
        console.error('Image failed to load:', e.target.src);
        // Fallback to original path if PUBLIC_URL version fails
        e.target.src = imageSrc;
      }}
      {...props}
    />
  );
};

export default PublicImage;
